import { useMemo } from 'react'

import { sortByPosition } from '@/shared/lib/array/sort-by-position'
import { filterVisibleForGuilds } from '@/shared/lib/guild/visibility'
import { useUserProgress } from '@/shared/hooks/useUserProgress'
import type { Document } from '@/types/document'

import { useGamificationDataStore } from './gamificationDataStore'

export const useLibraryStore = () => {
  const { documents: documentsRaw } = useGamificationDataStore(s =>
    s.getActiveProductData()
  )
  const { guildIds } = useUserProgress()

  const documents = useMemo(() => {
    // O bundle traz o conteúdo do evento inteiro; o recorte por guilda é
    // decidido aqui. A imposição de verdade é do servidor, na escrita.
    const visible = filterVisibleForGuilds(documentsRaw as Document[], guildIds)

    return visible.slice().sort(sortByPosition)
  }, [documentsRaw, guildIds])

  return {
    documents
  }
}
